import { Alert, Button, Card, Col, Row, Typography, Upload } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  CloseCircleOutlined,
  EditOutlined,
  FolderAddOutlined,
  PlusSquareOutlined,
  UploadOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Input, notification, Spin } from "antd";
import { v4 as uuidv4 } from "uuid";
import arrowLeft from "../../../src/assets/images/arrowLeft.png";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../apis/constants";

export default function NewModel() {
  const [modelName, setModelName] = useState("");
  const [modelBaseFace, setModelBaseFace] = useState({});
  const [ocassions, setOccassions] = useState([
    {
      _id: uuidv4(),
      name: "",
      imagePath: {},
    },
  ]);
  const navigate = useNavigate();
  const baseFaceRef = useRef();
  const ocassionRef = useRef();
  const [uploadBaseFaceInProgress, setUploadBaseFaceInProgress] =
    useState(false);
  const [ocassionUploadInProgress, setOcassionUploadInProgress] =
    useState(false);
  const [modelCreationInProgress, setModelCreationInProgress] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const handleNameChange = (e) => {
    setModelName(e.target.value);
    setModelBaseFace({
      name: e.target.value,
    });
  };

  useEffect(() => {
    return () => {
      setModelBaseFace({});
    };
  }, []);

  const handleBaseFaceUpload = async (e) => {
    let uploadedFile = e.target.files[0];
    async function fetchBaseFacePresignedUrl(file) {
      const token = localStorage.getItem("token");
      let method = "get";
      let url = `${baseUrl}/models/getPresignedUrl?modelName=${modelName}&filename=${file.name}&mimeType=${file.type}`;
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      };
      const fetching = await axios({
        method,
        url,
        headers,
      });

      return fetching;
    }

    async function finalImageUrl(data, file) {
      var id = data.key;
      var fileValue = file;
      const url = data.url;
      const result = await axios.put(`${url}`, fileValue);
      return result;
    }

    if (uploadedFile) {
      setUploadBaseFaceInProgress(true);
      const result = await fetchBaseFacePresignedUrl(uploadedFile);
      if (result && result.data) {
        const finalResult = await finalImageUrl(result.data, uploadedFile);
        if (finalResult && finalResult.status === 200) {
          setModelBaseFace({
            name: modelName,
            imagePath: { key: result.data.key },
          });

          api.success({
            message: "Great!",
            description: "Image has been successfully uploaded!",
            placement: "topRight",
          });
        } else {
          api.warning({
            message: "Ooops!",
            description: "Image has not been successfully uploaded!",
            placement: "topRight",
          });
        }
      }
      setUploadBaseFaceInProgress(false);
    }
  };

  const handleOccasionImageUpload = async (e, _id, occasionName) => {
    let uploadedFile = e.target.files[0];

    async function fetchBaseFacePresignedUrl(file) {
      const token = localStorage.getItem("token");
      let method = "get";
      let url = `${baseUrl}/models/getPresignedUrl?modelName=${modelName}&occasionName=${occasionName}&filename=${file.name}&mimeType=${file.type}`;
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      };
      const fetching = await axios({
        method,
        url,
        headers,
      });

      return fetching;
    }

    async function finalImageUrl(data, file) {
      var id = data.key;
      var fileValue = file;
      const url = data.url;
      const result = await axios.put(`${url}`, fileValue);
      return result;
    }

    if (uploadedFile) {
      setOcassionUploadInProgress(true);
      const result = await fetchBaseFacePresignedUrl(uploadedFile);
      if (result && result.data) {
        const finalResult = await finalImageUrl(result.data, uploadedFile);
        if (finalResult && finalResult.status === 200) {
          let localOccasions = [...ocassions];

          localOccasions.forEach((item) => {
            if (item._id === _id) {
              item.imagePath = {
                key: result.data.key,
              };
            }
          });

          setOccassions([...localOccasions]);

          api.success({
            message: "Great!",
            description: "Image has been successfully uploaded!",
            placement: "topRight",
          });
        } else {
          api.warning({
            message: "Ooops!",
            description: "Image has not been successfully uploaded!",
            placement: "topRight",
          });
        }
      }
      setOcassionUploadInProgress(false);
    }
  };

  const handleOccasionNameChange = (e, _id) => {
    let val = e.target.value;
    let localOccasions = [...ocassions];

    localOccasions.forEach((item) => {
      if (item._id === _id) {
        item.name = val;
      }
    });

    setOccassions([...localOccasions]);
  };

  const handleAddOcassions = () => {
    let localOccasions = [...ocassions];

    localOccasions.push({
      _id: uuidv4(),
      name: "",
      imagePath: {},
    });

    setOccassions([...localOccasions]);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setModelCreationInProgress(true);
    async function submitData(dataObj) {
      const token = localStorage.getItem("token");
      let method = "post";
      let url = `${baseUrl}/models/new`;
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      };
      const fetching = await axios({
        method,
        url,
        headers,
        data: dataObj,
      });

      return fetching;
    }

    let localOcassion = [...ocassions];
    let dataOcassions = localOcassion
      .map((item) => {
        return {
          name: item.name,
          image: {
            imagePath: item.imagePath,
          },
        };
      })
      .filter((item) => {
        if (item.name === "") {
          return false;
        }

        return true;
      });
    const dataObj = {
      name: modelName,
      baseFace: { ...modelBaseFace },
      occasions: [...dataOcassions],
    };

    const response = await submitData(dataObj);

    if (response && response.status === 200) {
      api.success({
        message: "Great!",
        description: "Model Succesfully Created!",
        placement: "topRight",
      });

      setModelBaseFace({});
      setModelName("");
      setOccassions([
        {
          _id: uuidv4(),
          name: "",
          imagePath: {},
        },
      ]);
      baseFaceRef.current.value = "";
      ocassionRef.current.value = "";
    } else {
      api.warning({
        message: "Ooops!",
        description: "Model has not been Successfully create!!",
        placement: "topRight",
      });
    }

    setModelCreationInProgress(false);
  };

  const handleCardRemove = (_id) => {
    if (ocassions.length === 1) {
      return;
    } else {
      let localOcassion = [...ocassions];
      let ocassionToShow = localOcassion.filter((item) => item._id !== _id);

      setOccassions([...ocassionToShow]);
    }
  };

  return (
    <>
      <img
        src={arrowLeft}
        alt=""
        style={{
          width: "30px",
          cursor: "pointer",
          margin: "5px",
          // padding: "10px",
        }}
        onClick={() => navigate(-1)}
      />
      {contextHolder}
      <Row
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          height: "92%",
        }}
      >
        <Col
          span={12}
          style={{
            border: "0.2px solid lightblue",
            padding: "12px",
            borderRadius: "5px",
          }}
        >
          <Col
            span={24}
            style={{
              marginBottom: "10px",
            }}
          >
            <Row>
              <Typography.Text
                strong
                style={{
                  marginBottom: "5px",
                }}
              >
                Name *{" "}
              </Typography.Text>
              <Input
                placeholder="Enter Model Name"
                value={modelName}
                onChange={handleNameChange}
                style={{
                  marginBottom: "5px",
                }}
              />
            </Row>
          </Col>
          <Col
            span={24}
            style={{
              marginBottom: "10px",
            }}
          >
            <Row>
              <Typography.Text
                strong
                style={{
                  marginBottom: "5px",
                }}
              >
                Base Face *{" "}
              </Typography.Text>
            </Row>
            <Row
              style={{
                display: "flex",
                justifyContent: "space-between",
                height: "max-content",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <Col span={24}>
                <label className="custom-file-upload">
                  <input
                    type="file"
                    onChange={(e) => handleBaseFaceUpload(e)}
                    accept=".png,.jpg,.jpeg"
                    disabled={!modelName.trim()}
                    style={{
                      marginBottom: "5px",
                    }}
                    ref={baseFaceRef}
                  />
                </label>
              </Col>
            </Row>
          </Col>
          <Col
            span={24}
            style={{
              marginBottom: "15px",
            }}
          >
            <Row
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography.Text strong>Ocassions * </Typography.Text>
              <Button
                shape="circle"
                type="ghost"
                style={{
                  padding: 0,
                }}
                icon={
                  ocassionUploadInProgress || uploadBaseFaceInProgress ? (
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{
                            fontSize: "12px",
                          }}
                        />
                      }
                    />
                  ) : (
                    <PlusSquareOutlined
                      style={{
                        width: "100%",
                      }}
                    />
                  )
                }
                onClick={(e) =>
                  !ocassionUploadInProgress &&
                  !uploadBaseFaceInProgress &&
                  handleAddOcassions(e)
                }
              />
            </Row>
            <Row>
              {ocassions &&
                ocassions.length > 0 &&
                ocassions.map((oCard, index) => {
                  return (
                    <div
                      key={oCard._id}
                      style={{
                        width: "100%",
                      }}
                    >
                      {" "}
                      {oCard._id && (
                        <Card
                          style={{
                            width: "100%",
                            marginBottom: "5px",
                            paddingTop: 0,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              padding: 0,
                            }}
                          >
                            <Button
                              shape="circle"
                              type="ghost"
                              style={{
                                padding: 0,
                              }}
                              icon={
                                <CloseCircleOutlined
                                  style={{
                                    width: "100%",
                                  }}
                                />
                              }
                              onClick={(e) => handleCardRemove(oCard._id)}
                            />
                          </div>
                          <Row>
                            <Typography.Text
                              strong
                              style={{
                                marginBottom: "5px",
                              }}
                            >
                              Name *{" "}
                            </Typography.Text>
                            <Input
                              placeholder="Enter Ocassion Name"
                              id={`ocassion_id_${oCard._id}`}
                              value={oCard.name}
                              onChange={(e) =>
                                handleOccasionNameChange(e, oCard._id)
                              }
                              style={{
                                marginBottom: "5px",
                              }}
                            />
                          </Row>
                          {oCard._id && (
                            <Row>
                              <label className="custom-file-upload">
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    handleOccasionImageUpload(
                                      e,
                                      oCard._id,
                                      oCard.name
                                    )
                                  }
                                  disabled={!modelName || !oCard.name.trim()}
                                  accept=".png,.jpg,.jpeg"
                                  ref={ocassionRef}
                                />
                              </label>
                            </Row>
                          )}
                        </Card>
                      )}
                    </div>
                  );
                })}
            </Row>
          </Col>
          <Col span={24}>
            <Row
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {!modelCreationInProgress ? (
                <Button
                  type="primary"
                  disabled={
                    !modelName.trim() ||
                    !modelBaseFace?.imagePath?.key ||
                    !ocassions?.[0]?.imagePath.key ||
                    ocassionUploadInProgress ||
                    uploadBaseFaceInProgress
                  }
                  onClick={handleFormSubmit}
                >
                  Submit
                </Button>
              ) : (
                <Button
                  type="primary"
                  icon={
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{
                            fontSize: "15px",
                          }}
                        />
                      }
                    />
                  }
                ></Button>
              )}
            </Row>
          </Col>
        </Col>
      </Row>
    </>
  );
}
